import * as React from 'react';

import { translate } from '~l10n/client';

import { Dialog, DialogProps } from '~shared/components/Dialog';
import { Divider } from '~shared/components/Divider';
import { ImportQuizBySoc } from '~teacher/components/ImportQuizBySoc';
import { ImportQuizBySpreadsheet } from '~teacher/components/ImportQuizBySpreadsheet';
import { PaywallDispatch } from '~teacher/components/PaywallDialog';

import {
  useImportQuizBySocToPersonal,
  useImportQuizBySpreadsheetToPersonal,
} from './hooks';

export interface ImportQuizDialogProps
  extends Pick<DialogProps, 'open' | 'onClose'> {
  parentId: number;
  paywallDispatch: PaywallDispatch;
}

export function ImportQuizToPersonalDialog({
  open,
  onClose,
  parentId,
  paywallDispatch,
}: ImportQuizDialogProps) {
  const importQuizBySocToPersonal = useImportQuizBySocToPersonal({
    parentId: parentId,
    onClose: () => onClose(false),
    paywallDispatch: paywallDispatch,
  });

  const importQuizByExcelToPersonal = useImportQuizBySpreadsheetToPersonal({
    paywallDispatch,
    parentId,
    onClose: () => onClose(false),
  });

  return (
    <Dialog
      open={open}
      id="import-quiz-dialog"
      title={translate('Import Quiz')}
      onClose={onClose}
      closeLabel={translate('Close')}
    >
      <div className="my-5">
        <Divider />
      </div>
      <div className="flex flex-col">
        {open ? (
          <ImportQuizBySoc
            importBySocNumber={importQuizBySocToPersonal.importBySocNumber}
            isDisabled={importQuizBySocToPersonal.isImportDisabled}
            error={
              importQuizBySocToPersonal.isError
                ? translate('Please check the SOC number and try again.')
                : null
            }
          />
        ) : null}
        {open ? (
          <ImportQuizBySpreadsheet
            id="import-quiz-field"
            isLoading={importQuizByExcelToPersonal.isLoading}
            error={importQuizByExcelToPersonal.error}
            isError={importQuizByExcelToPersonal.isError}
            progress={importQuizByExcelToPersonal.progressPercent}
            onUploadFile={importQuizByExcelToPersonal.handleUploadExcelFile}
          />
        ) : null}
      </div>
    </Dialog>
  );
}
